<template>
    <div>
        <vs-tabs v-model="activeTab" :position="isSmallerScreen ? 'top' : 'left'" class="tabs-shadow-none" id="tokens-tab" :key="isSmallerScreen">

            <vs-tab icon-pack="feather" icon="icon-list" :label="!isSmallerScreen ? $t(`ACCESTOKENS.listTokens`) : ''">
                <list-tokens></list-tokens>
            </vs-tab>

            <vs-tab icon-pack="feather" icon="icon-list" :label="!isSmallerScreen ? $t(`ACCESTOKENS.newTokens`) : ''">
                <create-tokens></create-tokens>
            </vs-tab>

        </vs-tabs>
    </div>
</template>

<script>
    import createTokens from './createToken.vue';
    import listTokens from './listTokens.vue';

    export default {
        components: { createTokens, listTokens },
        data() {
            return {
                activeTab: 0
            }
        },
        computed: {
            isSmallerScreen () {
                return this.$store.state.windowWidth < 768
            }            
        }
        
    }
</script>

<style lang="scss" scoped>

</style>